import {
  createRef,
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { matchPath, useHistory, useParams, withRouter } from 'react-router'
import { compose, setDisplayName } from 'react-recompose'
import Avatar from '@mui/material/Avatar'
import useTheme from '@mui/material/styles/useTheme'
import useMediaQuery from '@mui/material/useMediaQuery'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import CloseIcon from '@mui/icons-material/Close'
import MenuIcon from '@mui/icons-material/Menu'
import ButtonBase from '@mui/material/ButtonBase'
import Dialog from '@mui/material/Dialog'
import AppBar from '@mui/material/AppBar'
import FormControlLabel from '@mui/material/FormControlLabel'
import Divider from '@mui/material/Divider'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import MenuItem from '@mui/material/MenuItem'
import Menu from '@mui/material/Menu'
import Tooltip from '@mui/material/Tooltip'
import Checkbox from '@mui/material/Checkbox'
import { getProductSpecs, siteplans, getImagePrefix } from '@anewgo/utils'
import { CommunityIcon, FloorplanIcon, PlaceIcon } from '@anewgo/icons'
import clsx from 'clsx'
import { requireProps } from '../helper'
import { withBuilderAppConfig, withClient } from '../../hocs'
import { StoreContext } from '../../store'
import * as reducers from '../../store/reducers'
import FavoriteMenu from '../FavoriteMenu/FavoriteMenu'
import { apply, getPath, pipe } from '@anewgo/functions'
import '../../stylesheets/header.css'
import SectionDivider from '../SectionDivider/SectionDivider'
import AgentLoginDialog from '../AgentLoginDialog/AgentLoginDialog'
import {
  EVT_USER_ALIAS,
  EVT_TOGGLED_FAVORITES_MENU,
  EVT_CLICKED_HEADER_TAB,
  EVT_CLICKED_START_OVER,
  EVT_PROSPECT_SHARED_FAVORITE,
  EVT_PROSPECT_SHARED_FAVORITE_WITH,
} from '../../constants/eventTracking'
import { useEventTracker } from '../../utils/hooks'
import {
  ZERO_PRICE_TEXT,
  COMING_SOON_PRICE_TEXT,
  HEADER_HT,
} from '../../constants'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import TextField from '@mui/material/TextField'
import DialogActions from '@mui/material/DialogActions'
import Message from '../Message/Message'
import { apolloClient } from '../../graphql/enhancers'
import { SEND_FAVORITES_EMAIL } from '../../graphql'
import { isHomeSiteDisabled } from '../../utils'
import ContactUsButton from '../ContactUsButton/ContactUsButton'
import EmailBrochureButton from '../EmailBrochureButton/EmailBrochureButton'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Root, {
  classes,
  mainMenuButton,
  mobileMenuClasses,
  StyledMainMenuButton,
  StyledMobileMenuDialog,
  StyledSystemInfoDialog,
  StyledSystemInfoText,
  SubheaderDiv,
} from './HeaderStyles'
import { signOut } from '../../utils/auth'
import { loadProspect } from '../../services/prospect'
// import LoginLogoutButton from '../LoginLogoutButton/LoginLogoutButton'
// import { useAuth0 } from '@auth0/auth0-react'

const { isInventoryLot } = siteplans

const clientPath = '/client/:clientName'
const clientPlansPath = '/client/:clientName/plans'
const communityPath = '/client/:clientName/community/:communityName'
const communityPlansPath = '/client/:clientName/community/:communityName/plans'
const planPath = '/client/:clientName/community/:communityName/plan/:planName'
const siteplanPath = '/client/:clientName/community/:communityName/siteplan'
const inventoryPath = '/client/:clientName/community/:communityName/inventory'
const favoritesPath = '/client/:clientName/compareFavorites'
const standAloneInteriorsGalleryPath = '/client/:clientName/interiors'
const standAloneInteriorPath = '/client/:clientName/interior/:interiorId'
const SHARE_FAVORITES_PREFIX = 'share_favorites'
const getMatchParamsFromLocation = pipe(
  (location) => matchPath(location.pathname, { path: communityPath }),
  apply(getPath('params'))
)

/*
const Wrapper = styled('div')({
  height: 0,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'transparent',
  // boxShadow: '0px 12px 20px -5px rgba(0, 0, 0, 0.4)',
  zIndex: 1000,
})
*/

/*
const Nav = styled(NavLink)({
  textDecoration: 'none',
  fontSize: 24,
  padding: '0 7px',
})
*/

const MainMenuButton = ({
  title,
  dst,
  communityName,
  communityPath,
  handleClose,
  disableSiteplanButton,
}) => {
  const track = useEventTracker()
  const history = useHistory()
  const { clientName } = useParams()
  if (!clientName) {
    return null
  }
  let path = `/client/${clientName}`
  if (dst !== '' && communityPath) {
    if (!communityName) {
      return null
    }
    path += `/community/${communityName}/${dst}`
  }

  const handleClick = () => {
    const tab = communityPath ? dst : 'communities'
    track(EVT_CLICKED_HEADER_TAB, {
      communityName: communityName,
      location: tab,
    })

    if (handleClose) handleClose()
    history.push(path)
  }

  return (
    <StyledMainMenuButton
      onClick={disableSiteplanButton ? null : handleClick}
      style={disableSiteplanButton ? { cursor: 'not-allowed' } : {}}
    >
      <Typography
        variant="h6"
        classes={{ root: mainMenuButton.menuText }}
        style={disableSiteplanButton ? { color: 'whitesmoke' } : {}}
      >
        {title}
      </Typography>
      <svg
        className={mainMenuButton.svgLine}
        viewBox="0 0 280 100"
        width={'100%'}
        height={50}
        stroke={'#000000'}
        strokeWidth="4"
      >
        <path d="M0,100 L280,100" />
      </svg>
    </StyledMainMenuButton>
  )
}

const MainMenuIconButton = ({
  title,
  dst,
  classes,
  communityName,
  communityPath,
  icon,
  disableSiteplanButton,
}) => {
  const track = useEventTracker()
  const history = useHistory()
  const { clientName } = useParams()

  if (!clientName) {
    return null
  }

  let path = `/client/${clientName}`
  if (communityPath) {
    if (!communityName) {
      return null
    }
    path += `/community/${communityName}/${dst}`
  } else {
    path += `/${dst}`
  }

  const handleClick = () => {
    const tab = communityPath ? dst : 'communities'
    track(EVT_CLICKED_HEADER_TAB, {
      communityName: communityName,
      location: tab,
    })
    history.push(path)
  }

  return (
    <ButtonBase
      disabled={disableSiteplanButton}
      onClick={disableSiteplanButton ? null : handleClick}
      className={clsx(classes.btn, classes.mainMenuIconButton)}
    >
      {icon}
      <Typography
        classes={{ button: classes.iconButtonText }}
        variant={'button'}
      >
        {title}
      </Typography>
    </ButtonBase>
  )
}

const ClientLogo = ({ client, logoStyle }) => {
  if (!client.logo) return null
  const src = `${getImagePrefix(
    client.directoryName,
    'images/client/',
    '',
    client.logo.endsWith('.svg')
  )}${client.logo}`
  // The database stores the full URL, including the http:// or https:// protocol prefix.
  return (
    // eslint-disable-next-line jsx-a11y/img-redundant-alt
    <img
      className={logoStyle}
      src={src}
      alt={`Image of ${client.name} Logo`}
      data-testid="header_builder_menu"
    />
  )
}

const MobileMenuDialog = ({
  client,
  handleClose,
  open,
  communityName,
  iconSize,
  isSignedIn,
  handleSignIn,
  handleSignOut,
  prospect,
  disabledMenuItems,
  disableSiteplanButton,
}) => {
  const dst = client.website
  return (
    <StyledMobileMenuDialog open={open} fullScreen onClose={handleClose}>
      <AppBar className={mobileMenuClasses.appBar}>
        <Toolbar>
          <IconButton
            className={mobileMenuClasses.closeBtn}
            color="inherit"
            onClick={() => handleClose()}
            arial-label="Close"
            size="large"
          >
            <CloseIcon />
          </IconButton>
          <Typography
            className={mobileMenuClasses.dlgTitle}
            variant="h6"
            color="inherit"
          >
            MENU
          </Typography>
        </Toolbar>
      </AppBar>
      <div className={mobileMenuClasses.mobileMenuItemContainer}>
        {!disabledMenuItems.includes('communities') && (
          <ButtonBase className={mobileMenuClasses.mobileMenuItem}>
            <div className={mobileMenuClasses.mobileMenuIconContainer}>
              <CommunityIcon width={iconSize} height={iconSize} />
            </div>
            <MainMenuButton
              data-testid="communities_button"
              title="Communities"
              dst=""
              handleClose={handleClose}
            />
          </ButtonBase>
        )}
        {!disabledMenuItems.includes('plans') && communityName && (
          <ButtonBase className={mobileMenuClasses.mobileMenuItem}>
            <div className={mobileMenuClasses.mobileMenuIconContainer}>
              <FloorplanIcon width={iconSize} height={iconSize} />
            </div>
            <MainMenuButton
              data-testid="plans_button"
              title="Plans"
              communityPath
              communityName={communityName}
              dst="plans"
              handleClose={handleClose}
            />
          </ButtonBase>
        )}
        {!disabledMenuItems.includes('siteplan') && communityName && (
          <ButtonBase
            className={mobileMenuClasses.mobileMenuItem}
            disabled={disableSiteplanButton}
          >
            <div className={mobileMenuClasses.mobileMenuIconContainer}>
              <PlaceIcon
                width={iconSize}
                height={iconSize}
                style={disableSiteplanButton ? { color: 'whitesmoke' } : {}}
              />
            </div>
            <MainMenuButton
              data-testid="siteplan_button"
              title="Siteplan"
              communityPath
              communityName={communityName}
              dst="siteplan"
              handleClose={handleClose}
              disableSiteplanButton={disableSiteplanButton}
            />
          </ButtonBase>
        )}
        <SectionDivider />
        <div
          style={{ cursor: 'pointer', margin: '0 auto' }}
          onClick={() => {
            window.open('/adapolicy', '_blank')
          }}
        >
          <Typography variant="button">
            View our ADA Policy and Disclaimer
          </Typography>
        </div>
        <SectionDivider />
        {dst && (
          <>
            <div
              style={{ cursor: 'pointer', margin: '0 auto' }}
              onClick={() => {
                if (dst) {
                  window.open(dst, '_blank')
                }
              }}
            >
              <Typography variant="button">{`Visit ${client.name}`}</Typography>
            </div>
            <SectionDivider />
          </>
        )}
        {isSignedIn ? (
          <div className={mobileMenuClasses.mobileMenuItem}>
            <ButtonBase
              data-testid="sign_out_button"
              className={clsx(
                mobileMenuClasses.btn,
                mobileMenuClasses.btnSignIn,
                mobileMenuClasses.btnSignInAlready
              )}
              onClick={handleSignOut}
            >
              <Avatar
                alt={prospect.name}
                src={`${getImagePrefix(null, 'prospects/')}${prospect.picture}`}
                className={classes.avatar}
              />
              <Typography
                classes={{ button: mobileMenuClasses.signInBtnText }}
                variant={'button'}
              >
                Sign Out
              </Typography>
            </ButtonBase>
          </div>
        ) : (
          <div className={mobileMenuClasses.mobileMenuItem}>
            <ButtonBase
              className={clsx(
                mobileMenuClasses.btn,
                mobileMenuClasses.btnSignIn
              )}
              onClick={handleSignIn}
            >
              <AccountCircleIcon className={classes.icon} />
              <Typography
                classes={{ button: mobileMenuClasses.btnText }}
                variant={'button'}
              >
                Sign In
              </Typography>
            </ButtonBase>
          </div>
        )}
      </div>
    </StyledMobileMenuDialog>
  )
}

const SystemInfoDialog = ({ open, handleClose }) => {
  const currentYear = new Date().getFullYear()
  return (
    <StyledSystemInfoDialog
      open={open}
      onClose={(ev) => handleClose(ev, true)}
      aria-labelledby="form-dialog-title"
      maxWidth="md"
    >
      <StyledSystemInfoText>My Home App</StyledSystemInfoText>
      <StyledSystemInfoText>
        Version {process.env.REACT_APP_VERSION}
      </StyledSystemInfoText>
      <StyledSystemInfoText>© {currentYear} anewgo, Inc.</StyledSystemInfoText>
      <a href="https://anewgosell.com/" target="_blank" rel="noreferrer">
        https://anewgosell.com/
      </a>
    </StyledSystemInfoDialog>
  )
}

const ShareFavoritesDialog = ({
  classes,
  handleClose,
  open,
  emails,
  emailsError,
  isProspectLoading,
  setEmails,
  setEmailsError,
  openMessage,
  setOpenMessage,
  setShareFavsWithCommunityAgent,
  shareFavsWithCommunityAgent,
  setContactMethodsSelected,
  contactMethodsSelected,
  notes,
  setNotes,
}) => {
  const handleEmailsChange = (emailsInput) => {
    setEmailsError(undefined)
    setEmails(emailsInput)
  }

  const handleNotesChange = (notesInput) => {
    setNotes(notesInput)
  }

  const handleContactMethodsChange = (addOrRemove, value) => {
    let methodsOfContact = contactMethodsSelected
    if (addOrRemove === 'REMOVE') {
      methodsOfContact = methodsOfContact.filter(
        (contactMethod) => contactMethod !== value
      )
      setContactMethodsSelected(methodsOfContact)
    } else {
      methodsOfContact = [...methodsOfContact, value]
      setContactMethodsSelected(methodsOfContact)
    }
  }
  return (
    <div>
      <Dialog
        open={open}
        onClose={(ev) => handleClose(ev, true)}
        aria-labelledby="form-dialog-title"
        maxWidth="md"
        fullWidth={true}
        classes={{ paper: classes.paper }}
      >
        <IconButton
          style={{
            position: 'absolute',
            right: 0,
            top: 4,
            color: 'rgba(0, 0, 0, 0.54)',
          }}
          color="inherit"
          onClick={(ev) => handleClose(ev, true)}
          aria-label="Close"
          size="large"
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle id="form-dialog-title">
          <Typography variant="h4" style={{ paddingRight: '24px' }}>
            Share your Favorites
          </Typography>
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Email Addresses (separate addresses with comma)"
            helperText={emailsError}
            error={!!emailsError}
            variant="standard"
            type="text"
            margin="dense"
            fullWidth
            required
            value={emails}
            onChange={(ev) => handleEmailsChange(ev.target.value)}
            data-testid={`${SHARE_FAVORITES_PREFIX}_email_address_input`}
          />
          <div style={{ width: '100%', marginTop: '20px' }}>
            <div style={{ width: '60%', float: 'left' }}>
              <div style={{ marginBottom: '20px' }}>
                <TextField
                  style={{ width: '90%' }}
                  id="outlined-multiline-static"
                  label="Enter Notes"
                  multiline
                  rows={8}
                  variant="outlined"
                  value={notes}
                  onChange={(ev) => handleNotesChange(ev.target.value)}
                  data-testid={`${SHARE_FAVORITES_PREFIX}_notes_input`}
                />
              </div>
              <FormControlLabel
                control={
                  <Checkbox
                    data-testid="share_with_agent_checkbox"
                    checked={shareFavsWithCommunityAgent}
                    onChange={() =>
                      setShareFavsWithCommunityAgent(
                        !shareFavsWithCommunityAgent
                      )
                    }
                    name="shareWithCommunitySalesAgentCheck"
                    color="primary"
                  />
                }
                label="Share with Community Sales Agent"
              />
            </div>
            <div style={{ width: '40%', float: 'left' }}>
              <Typography variant="subtitle1">
                I would like to be contacted by:
              </Typography>
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      data-testid={`${SHARE_FAVORITES_PREFIX}_phone_checkbox`}
                      checked={contactMethodsSelected.some(
                        (method) => method === 'PHONE'
                      )}
                      onChange={() =>
                        contactMethodsSelected.some(
                          (method) => method === 'PHONE'
                        )
                          ? handleContactMethodsChange('REMOVE', 'PHONE')
                          : handleContactMethodsChange('ADD', 'PHONE')
                      }
                      name="contactByPhone"
                      color="primary"
                    />
                  }
                  label="Phone"
                />
              </div>
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      data-testid={`${SHARE_FAVORITES_PREFIX}_email_checkbox`}
                      checked={contactMethodsSelected.some(
                        (method) => method === 'EMAIL'
                      )}
                      onChange={() =>
                        contactMethodsSelected.some(
                          (method) => method === 'EMAIL'
                        )
                          ? handleContactMethodsChange('REMOVE', 'EMAIL')
                          : handleContactMethodsChange('ADD', 'EMAIL')
                      }
                      name="contactByEmail"
                      color="primary"
                    />
                  }
                  label="Email"
                />
              </div>
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      data-testid={`${SHARE_FAVORITES_PREFIX}_text_checkbox`}
                      checked={contactMethodsSelected.some(
                        (method) => method === 'TEXT'
                      )}
                      onChange={() =>
                        contactMethodsSelected.some(
                          (method) => method === 'TEXT'
                        )
                          ? handleContactMethodsChange('REMOVE', 'TEXT')
                          : handleContactMethodsChange('ADD', 'TEXT')
                      }
                      name="contactByText"
                      color="primary"
                    />
                  }
                  label="Text"
                />
              </div>
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      data-testid={`${SHARE_FAVORITES_PREFIX}_video_conference_checkbox`}
                      checked={contactMethodsSelected.some(
                        (method) => method === 'VIDEO_CONFERENCE'
                      )}
                      onChange={() =>
                        contactMethodsSelected.some(
                          (method) => method === 'VIDEO_CONFERENCE'
                        )
                          ? handleContactMethodsChange(
                              'REMOVE',
                              'VIDEO_CONFERENCE'
                            )
                          : handleContactMethodsChange(
                              'ADD',
                              'VIDEO_CONFERENCE'
                            )
                      }
                      name="contactByVideoConference"
                      color="primary"
                    />
                  }
                  label="Video Conference"
                />
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(ev) => handleClose(ev, true)}
            color="secondary"
            data-testid={`${SHARE_FAVORITES_PREFIX}_cancel_button`}
          >
            Cancel
          </Button>
          <Button
            onClick={(ev) => handleClose(ev, false)}
            disabled={isProspectLoading}
            color="primary"
            data-testid={`${SHARE_FAVORITES_PREFIX}_share_button`}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
      <Message
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={openMessage}
        autoHideDuration={4000}
        handleClose={() => {
          setOpenMessage(false)
        }}
        variant="success"
        message="Sent Favorites Link!"
      />
    </div>
  )
}

export const toggleMenu = async (
  menuType,
  val,
  dispatch,
  reducers,
  track = null
) => {
  if (menuType === 'favMenu') {
    track(EVT_TOGGLED_FAVORITES_MENU, {
      active: val,
    })
    dispatch(reducers.setFavMenuOpen(val))
  }
}

const Header = compose(
  withClient,
  withBuilderAppConfig,
  requireProps({
    keys: ['client', 'builderAppConfig'],
    loadingSpinner: false,
  }),
  setDisplayName('Header'),
  withRouter
)(({ builderAppConfig, client, location, history, setBuyerLoginDialog }) => {
  const track = useEventTracker()
  const {
    dispatch,
    isSignedIn,
    prospect,
    anonymousProspect,
    selection,
    uiConfig,
    prospectToken,
  } = useContext(StoreContext)
  const { lot, community } = selection
  // const { logout, loginWithPopup } = useAuth0()
  const { clientName } = useParams()
  const subHeaderRef = useRef(null)
  const isInventory = apply(isInventoryLot)(lot)
  const isInventoryHomeWithNoPrice = isInventory && !lot.inventory.price
  const pricing = community && community.pricing
  const { costValue } = getProductSpecs(selection)
  const { mobile, favMenuOpen, iconSize, loading, tgtCommunities, localAgent } =
    uiConfig
  const [disableSiteplanButton, setDisableSiteplanButton] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [isSystemInfoDialogOpen, setIsSystemInfoDialogOpen] = useState(false)
  const [isShareFavsDialogOpen, setShareFavsDialogOpen] = useState(false)
  const [emails, setEmails] = useState([])
  const [emailsError, setEmailsError] = useState(undefined)
  const [openMessage, setOpenMessage] = useState(false)
  const [shareFavsWithCommunityAgent, setShareFavsWithCommunityAgent] =
    useState(true)
  const [contactMethodsSelected, setContactMethodsSelected] = useState([])
  const [notes, setNotes] = useState(null)
  const buttonElement = createRef()

  const handleUserKeyPress = useCallback((event) => {
    const { keyCode } = event
    if (keyCode === 13) {
      document.activeElement.click()
    }
  }, [])

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress)
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress)
    }
  }, [handleUserKeyPress])

  const prospectId = prospect && prospect.id

  useEffect(() => {
    if (prospect && prospect.preferredContactMethods) {
      const contactMethods = [...new Set(prospect.preferredContactMethods)]
      setContactMethodsSelected(contactMethods)
    }
  }, [prospectId])

  const tgtCommunitiesString =
    tgtCommunities && JSON.stringify(tgtCommunities.map((comm) => comm.id))
  const communityId = community && community.id

  useEffect(() => {
    const doesTgtCommunityHaveSiteplan = (targetComms) => {
      if (targetComms && targetComms.length === 1) {
        if (!isHomeSiteDisabled(targetComms[0])) {
          return true
        }
      } else if (!isHomeSiteDisabled(community)) {
        return true
      }
      return false
    }
    setDisableSiteplanButton(!doesTgtCommunityHaveSiteplan(tgtCommunities))
  }, [tgtCommunitiesString, communityId])

  const disabledMenuItems =
    getPath('header', 'disableList')(builderAppConfig) || []

  const atClientRoot = matchPath(location.pathname, {
    path: clientPath,
    exact: true,
  })
  const atFavoritesPage = matchPath(location.pathname, {
    path: favoritesPath,
    exact: true,
  })
  const atStandaloneInteriorPage = matchPath(location.pathname, {
    path: standAloneInteriorPath,
    exact: true,
  })
  const atStandAloneInteriorsPages =
    atStandaloneInteriorPage ||
    matchPath(location.pathname, {
      path: standAloneInteriorsGalleryPath,
      exact: true,
    })
  const atPlanPage = matchPath(location.pathname, {
    path: planPath,
    exact: true,
  })
  const atInventoryPage = matchPath(location.pathname, {
    path: inventoryPath,
    exact: true,
  })
  const atPlansPage = matchPath(location.pathname, {
    path: clientPlansPath,
    exact: true,
  })
  const atSiteplanPage = matchPath(location.pathname, {
    path: siteplanPath,
    exact: true,
  })
  const atCommunityPlansPage = matchPath(`${location.pathname}`, {
    path: communityPlansPath,
    exact: true,
  })
  const theme = useTheme()
  const matchXs = useMediaQuery(theme.breakpoints.down('sm'))
  const matchSm = useMediaQuery(theme.breakpoints.down('md'))

  const hasSlideOutHeader = atPlanPage || atInventoryPage

  const [isAgentDialogOpen, setIsAgentDialogOpen] = useState(false)

  // expanded header height: plans
  const height = uiConfig.headerHeight

  const localStyles = {
    height,
  }

  const { communityName } = getMatchParamsFromLocation(location) || {}
  const [anchorEl, setAnchorEl] = useState(null)
  const [isProspectLoading, setIsProspectLoading] = useState(false)
  const handleMenuClick = (event) => {
    if (!anchorEl) {
      setAnchorEl(event.currentTarget)
    } else {
      setAnchorEl(null)
    }
  }

  useEffect(() => {
    dispatch(reducers.setSubHeaderRef(subHeaderRef.current))
  }, [dispatch, subHeaderRef.current])

  const handleSignIn = () => {
    if (prospectToken && prospectToken?.validation?.isFirstSignIn) {
      dispatch(reducers.setConsentToNewClientLoginDialogOpen(true))
      return
    } else {
      setBuyerLoginDialog({ open: true })
    }
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const areFavoritesShareable =
    prospect && prospect.email && location.search.includes(prospect.email)

  const handleAgentSignOut = () => {
    dispatch(reducers.setLocalAgent(null))
  }

  const handleAgentSignIn = () => {
    setIsAgentDialogOpen(true)
  }

  const handleSignOut = async () => {
    track(EVT_USER_ALIAS, {
      lastUserId: prospect.email,
      nextUserId: anonymousProspect,
      userAction: 'sign-out',
    })
    await signOut({
      dispatch,
      clientName: client.altName,
      uiConfig,
    })
  }

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const displayRightButtons = () => {
    return (
      <Fragment>
        {atStandaloneInteriorPage && (
          <EmailBrochureButton data-testid="header_interior_brochure_button" />
        )}
        <ContactUsButton data-testid="contact_us_button" />
        {!atStandAloneInteriorsPages && (
          <FavoriteMenu
            data-testid="favorites_button"
            shareDialogHandler={handleOpenShareFavoritesDialog}
            isMobile={mobile}
            isShareDialogOpen={isShareFavsDialogOpen}
            openDrawer={favMenuOpen}
            setOpenDrawer={(val) =>
              toggleMenu('favMenu', val, dispatch, reducers, track)
            }
          />
        )}
        {isSignedIn && (
          <ButtonBase
            data-testid="header_sign_out_button"
            className={clsx(
              classes.btn,
              classes.btnSignIn,
              classes.btnSignInAlready
            )}
            onClick={handleSignOut}
          >
            <Avatar
              alt={prospect.name}
              src={`${getImagePrefix(null, 'prospects/')}${prospect.picture}`}
              className={classes.avatar}
            />
            <Typography
              classes={{
                button: clsx(classes.btnText, classes.signInBtnText),
              }}
              variant={'button'}
            >
              Sign Out
            </Typography>
          </ButtonBase>
        )}
        {!isSignedIn && (
          <ButtonBase
            data-testid="header_sign_in_button"
            className={clsx(classes.btn, classes.btnSignIn)}
            onClick={(e) => handleSignIn(e)}
            ref={buttonElement}
          >
            <AccountCircleIcon className={classes.icon} />
            <Typography
              classes={{ button: classes.btnText }}
              variant={'button'}
            >
              Sign In
            </Typography>
          </ButtonBase>
        )}
        {
          // <LoginLogoutButton handleSignIn={handleSignIn} />
        }
        <AgentLoginDialog
          isOpen={isAgentDialogOpen}
          setIsOpen={setIsAgentDialogOpen}
        />
      </Fragment>
    )
  }

  const openSystemInfoDialog = () => {
    setIsSystemInfoDialogOpen(true)
  }

  const closeSystemInfoDialog = () => {
    setIsSystemInfoDialogOpen(false)
  }

  const handleOpenShareFavoritesDialog = async () => {
    setShareFavsDialogOpen(true)
    setIsProspectLoading(true)
    await loadProspect({
      clientName,
      dispatch,
      selection,
      anonymousProspect,
      track,
      uiConfig,
      newSignIn: false,
    })
    setIsProspectLoading(false)
  }

  const handleStartOver = () => {
    track(EVT_CLICKED_START_OVER, {
      location: history.location.pathname,
    })

    dispatch(reducers.startOver())
    history.push(`/client/${client.altName}`)
    handleMenuClose()
  }

  const renderMobileFormFactor = () => {
    const subHeaderClass = Boolean(atPlansPage || atCommunityPlansPage)
      ? clsx(classes.subHeader, classes.atPlansPage)
      : classes.subHeader
    return (
      <>
        <div className={atPlanPage ? classes.root : classes.root_mobile}>
          <div className={classes.mainHeader}>
            <div className={classes.leftGrpContainer}>
              <ButtonBase
                className={classes.btn}
                onClick={() => toggleMobileMenu()}
              >
                {client.logo ? (
                  <ClientLogo
                    client={client}
                    logoStyle={classes.mobileMenuIcon}
                  />
                ) : (
                  <MenuIcon className={classes.icon} />
                )}
                <Typography
                  classes={{ button: classes.btnText }}
                  variant={'button'}
                >
                  Menu
                </Typography>
              </ButtonBase>
            </div>
            <div className={classes.rightGrpContainer}>
              {displayRightButtons()}
            </div>
          </div>
          <Divider
            variant="middle"
            style={{ zIndex: 2, backgroundColor: '#E0E0E0' }}
          />
          <div
            className={
              atClientRoot ? classes.clientRootSubheader : subHeaderClass
            }
          >
            <div>
              {!matchXs && isInventoryHomeWithNoPrice && atInventoryPage && (
                <span className={classes.isInventoryHomeWithZeroPrice}>
                  {lot.inventory.price == null
                    ? COMING_SOON_PRICE_TEXT
                    : ZERO_PRICE_TEXT}
                </span>
              )}
            </div>
          </div>
        </div>
        <MobileMenuDialog
          open={mobileMenuOpen}
          handleClose={toggleMobileMenu}
          classes={classes}
          client={client}
          history={history}
          communityName={communityName}
          iconSize={iconSize}
          isSignedIn={isSignedIn}
          prospect={prospect}
          handleSignIn={handleSignIn}
          handleSignOut={handleSignOut}
          disabledMenuItems={disabledMenuItems}
          disableSiteplanButton={disableSiteplanButton}
        />
      </>
    )
  }

  const renderNormalFormFactor = () => {
    let rootClass = classes.root
    if (atClientRoot) {
      rootClass = clsx(classes.root, classes.atClientRoot)
    } else if (atSiteplanPage && !matchSm) {
      rootClass = clsx(classes.root, classes.atSiteplanPageRoot)
    }
    const subHeaderClass = Boolean(
      atPlansPage || atCommunityPlansPage || atSiteplanPage
    )
      ? clsx(classes.subHeader, classes.atPlansPage)
      : classes.subHeader
    const dst = client.website
    return (
      <div className={rootClass} style={localStyles}>
        <div className={classes.mainHeader}>
          <div className={classes.leftGrpContainer}>
            {client && (
              <>
                <div
                  className={classes.leftGrpContainer}
                  aria-controls="logo-menu"
                  aria-haspopup="true"
                  aria-label="Click to open navigation menu"
                  tabIndex="0"
                  onClick={handleMenuClick}
                  style={{ cursor: 'pointer' }}
                  data-testid="builder_menu"
                >
                  <ClientLogo logoStyle={classes.logo} client={client} />
                </div>
                <Menu
                  id="logo-menu"
                  anchorEl={anchorEl}
                  open={anchorEl ? true : false}
                  onClose={handleMenuClose}
                >
                  {!builderAppConfig.hideStartOver &&
                    history.location.pathname !==
                      `/client/${client.altName}` && (
                      <MenuItem
                        aria-label="Click Start Over to return to the start page"
                        data-testid="header_start_over_button"
                        onClick={handleStartOver}
                      >
                        Start Over
                      </MenuItem>
                    )}
                  {dst && (
                    <MenuItem
                      aria-label={`Click visit ${client.name} to open a new window and view the ${client.name} website`}
                      data-testid="header_visit_builder_button"
                      onClick={() => {
                        if (dst) {
                          window.open(dst, '_blank')
                        }
                        handleMenuClose()
                      }}
                    >
                      {`Visit ${client.name}`}
                    </MenuItem>
                  )}
                  <MenuItem
                    aria-label="Click Ada Disclaimer and Policy to open a new window to view the disclaimer and policy"
                    data-testid="header_disclaimer_policy_button"
                    onClick={() => {
                      window.open('/adapolicy', '_blank')
                      handleMenuClose()
                    }}
                  >
                    ADA Disclaimer and Policy
                  </MenuItem>
                  <MenuItem
                    aria-label={`Click to open system info dialog`}
                    data-testid="header_system_info_button"
                    onClick={() => openSystemInfoDialog()}
                  >
                    System Info
                  </MenuItem>
                  <Divider variant="middle" />
                  {!localAgent && (
                    <Tooltip title="Click to Sign In" placement="top">
                      <MenuItem
                        aria-label="Agent sign in"
                        data-testid="header_agent_sign_in_button"
                        onClick={handleAgentSignIn}
                      >
                        Agent Sign In
                      </MenuItem>
                    </Tooltip>
                  )}
                  {localAgent && (
                    <Tooltip title="Click to Sign Out" placement="top">
                      <MenuItem
                        aria-label="Agent sign out"
                        data-testid="header_agent_sign_out_button"
                        onClick={handleAgentSignOut}
                      >
                        {localAgent.name}
                      </MenuItem>
                    </Tooltip>
                  )}
                </Menu>
              </>
            )}
          </div>
          <div
            className={
              atFavoritesPage
                ? classes.favoritesMainGrpContainer
                : classes.mainGrpContainer
            }
          >
            {!disabledMenuItems.includes('communities') && !atFavoritesPage && (
              <MainMenuButton title={'Communities'} dst={''} />
            )}
            {atFavoritesPage && history.length > 1 && (
              <Button
                data-testid={`${SHARE_FAVORITES_PREFIX}_go_back_button`}
                startIcon={<ArrowBackIcon />}
                style={{ height: '60%', margin: 'auto 0px auto 10px' }}
                variant={'contained'}
                color={'primary'}
                onClick={() => history.goBack()}
              >
                Go Back
              </Button>
            )}
            {atFavoritesPage && prospect && areFavoritesShareable && (
              <Button
                data-testid="share_favorites_button"
                style={{ height: '60%', margin: 'auto 0px auto 10px' }}
                variant={'outlined'}
                color={'primary'}
                onClick={() => handleOpenShareFavoritesDialog()}
              >
                Share Favorites
              </Button>
            )}
            {/* history will have no length if link was opened from shared email*/}
            {!disabledMenuItems.includes('plans') && (
              <>
                <MainMenuButton
                  title={'Plans'}
                  communityPath
                  communityName={communityName}
                  dst={'plans'}
                />
                <MainMenuIconButton
                  title={'Plans'}
                  classes={classes}
                  communityPath
                  communityName={communityName}
                  dst={'plans'}
                  icon={<FloorplanIcon width={iconSize} height={iconSize} />}
                />
              </>
            )}
            {!disabledMenuItems.includes('siteplan') && (
              <>
                <MainMenuButton
                  title={'Siteplan'}
                  communityPath
                  communityName={communityName}
                  dst={'siteplan'}
                  disableSiteplanButton={disableSiteplanButton}
                />
                <MainMenuIconButton
                  title={'Siteplan'}
                  communityPath
                  communityName={communityName}
                  dst={'siteplan'}
                  classes={classes}
                  iconSize={iconSize}
                  icon={<PlaceIcon width={iconSize} height={iconSize} />}
                  disableSiteplanButton={disableSiteplanButton}
                />
              </>
            )}
          </div>
          <div className={classes.rightGrpContainer}>
            {displayRightButtons()}
          </div>
        </div>
        {!atClientRoot && !atSiteplanPage && (
          <Fragment>
            <Divider variant="middle" />
            <SubheaderDiv ref={subHeaderRef} atPlanPage={atPlanPage} />
          </Fragment>
        )}
      </div>
    )
  }

  // r e n d e r
  const validateEmailAddress = (emailAddress) => {
    return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(emailAddress)
  }

  const handleClose = (ev, cancel) => {
    if (cancel) {
      setShareFavsDialogOpen(false)
      return
    }
    const emailsArray = emails && emails.length && emails.split(',')
    let communityAgentsEmailArray = prospect.favorites.map((favorite) => {
      if (
        favorite.community &&
        favorite.community.agents &&
        favorite.community.agents.length &&
        favorite.community.agents[0] &&
        favorite.community.agents[0].email
      ) {
        return favorite.community.agents[0].email
      }
    })
    communityAgentsEmailArray = communityAgentsEmailArray.filter(
      (entry) => !!entry
    )

    // Deduplicate communityAgentsEmailArray
    communityAgentsEmailArray = [...new Set(communityAgentsEmailArray)]

    let validatedEmails = []
    if (emails && !emails.length) {
      setEmailsError('Please provide at least one email address')
      return
    } else {
      for (const emailAddress of emailsArray) {
        if (!validateEmailAddress(emailAddress.trim())) {
          setEmailsError(
            'Please provide valid email addresses separated by ", "'
          )
          return
        } else {
          //for some reason emails.trim().split(',') is not trimming the string
          validatedEmails.push(emailAddress.trim())
        }
      }
    }
    if (emailsError) {
      return
    }
    apolloClient
      .mutate({
        mutation: SEND_FAVORITES_EMAIL,
        variables: {
          prospectName: prospect.name || 'Unknown',
          prospectEmail: prospect.email,
          friendsEmails: validatedEmails,
          agentsEmails:
            communityAgentsEmailArray.length && shareFavsWithCommunityAgent
              ? communityAgentsEmailArray
              : null,
          notes: notes,
          preferredContactMethod: contactMethodsSelected,
          clientName,
          linkAddress: `${process.env.REACT_APP_TRUSS}/client/${client.altName}/compareFavorites?email=${prospect.email}&name=${prospect.name}`,
          clientLogoSrc: client.logo
            ? `${getImagePrefix(
                client.directoryName,
                'images/client/',
                'w_100,c_scale',
                client.logo.endsWith('.svg')
              )}${client.logo}`
            : null,
        },
      })
      .then(() => {
        const timeSharedAt = Date.now()
        const sharedFavoritesWith = validatedEmails.concat(
          communityAgentsEmailArray
        )
        prospect.favorites.forEach((favorite) => {
          track(EVT_PROSPECT_SHARED_FAVORITE, {
            prospectEmail: prospect.email,
            communityId: favorite.communityId,
            planId: favorite.planId,
            elevationId: favorite.elevationId,
            lotId: favorite.lotId,
            sharedAt: timeSharedAt,
          })
        })
        sharedFavoritesWith.forEach((favoriteRecipient) => {
          track(EVT_PROSPECT_SHARED_FAVORITE_WITH, {
            prospectEmail: prospect.email,
            destEmail: favoriteRecipient,
            sharedAt: timeSharedAt,
          })
        })
        setOpenMessage(true)
        setTimeout(() => {
          setShareFavsDialogOpen(false)
        }, 4000)
      })
      .catch((error) => {
        console.error('Error sending favorites email', error)
      })
  }

  return (
    <Root
      sx={{
        height: hasSlideOutHeader ? HEADER_HT : 'unset',
        zIndex: hasSlideOutHeader ? 1 : 'unset',
        position: hasSlideOutHeader ? 'relative' : 'unset',
      }}
    >
      {!mobile && renderNormalFormFactor()}
      {mobile && renderMobileFormFactor()}
      <SystemInfoDialog
        open={isSystemInfoDialogOpen}
        handleClose={closeSystemInfoDialog}
        classes={classes}
      />
      <ShareFavoritesDialog
        open={isShareFavsDialogOpen}
        handleClose={handleClose}
        classes={classes}
        client={client}
        emails={emails}
        emailsError={emailsError}
        setEmails={setEmails}
        setEmailsError={setEmailsError}
        openMessage={openMessage}
        setOpenMessage={setOpenMessage}
        isProspectLoading={isProspectLoading}
        setShareFavsWithCommunityAgent={setShareFavsWithCommunityAgent}
        shareFavsWithCommunityAgent={shareFavsWithCommunityAgent}
        setContactMethodsSelected={setContactMethodsSelected}
        contactMethodsSelected={contactMethodsSelected}
        notes={notes}
        setNotes={setNotes}
      />
    </Root>
  )
})

export default Header
